var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vue-recaptcha',_vm._g(_vm._b({staticClass:"recaptcha",attrs:{"recaptchaHost":"www.recaptcha.net","sitekey":_vm.siteKey,"loadRecaptchaScript":true}},'vue-recaptcha',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }